var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lm"},[_c('Header'),_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":_vm.height,"frameborder":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }